import { render, staticRenderFns } from "./TCAndPrivacyPolicyLinks.vue?vue&type=template&id=5cfc28f8"
import script from "./TCAndPrivacyPolicyLinks.vue?vue&type=script&lang=js"
export * from "./TCAndPrivacyPolicyLinks.vue?vue&type=script&lang=js"
import style0 from "./TCAndPrivacyPolicyLinks.vue?vue&type=style&index=0&id=5cfc28f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports